import {
  createContext,
  useContext,
  useState,
  useMemo,
  useCallback,
} from "react";

import {
  getRecruitmentMethodes,
  deleteRecruitmentMethodById,
  getRecruitmentMethodById,
  createRecruitmentMethod,
  updateRecruitmentMethodById,
} from "./queries";

const RecruitmentMethodContext = createContext({});

export const useRecruitmentMethodContext = () =>
  useContext(RecruitmentMethodContext);

export const RecruitmentMethodProvider = ({ ...props }) => {
  const [recruitmentMethodPerId, setRecruitmentMethodPerId] = useState({});
  const [recruitmentMethodList, setRecruitmentMethodList] = useState([]);

  const recruitmentMethodListGetter = useCallback(async () => {
    try {
      if (recruitmentMethodList.length === 0) {
        const result = await getRecruitmentMethodes();
        setRecruitmentMethodList(result);
      }
    } catch (e) {
      console.error("recruitmentMethodListGetter", e);
      throw e;
    }
  }, [recruitmentMethodList]);

  const recruitmentMethodByIdGetter = useCallback(
    async (id) => {
      try {
        setRecruitmentMethodPerId(await getRecruitmentMethodById(id));
      } catch (e) {
        console.error("recruitmentMethodByIdGetter", e);
        throw e;
      }
    },
    [setRecruitmentMethodPerId]
  );

  const recruitmentMethodDeleteById = useCallback(
    async (id) => {
      try {
        await deleteRecruitmentMethodById(id);
        setRecruitmentMethodList((old) => old.filter((row) => row.id !== id));
      } catch (e) {
        console.error("recruitmentMethodDeleteById", e);
        throw e;
      }
    },
    [setRecruitmentMethodList]
  );

  const recruitmentMethodCreate = useCallback(
    async (data) => {
      try {
        const recruitmentMethod = await createRecruitmentMethod(data);
        setRecruitmentMethodList((old) => [...old, recruitmentMethod]);
      } catch (e) {
        console.error("recruitmentMethodCreate", e);
        throw e;
      }
    },
    [setRecruitmentMethodList]
  );

  const recruitmentMethodUpdateById = useCallback(async (id, data) => {
    try {
      const updatedRecruitmentMethod = await updateRecruitmentMethodById(
        id,
        data
      );
      setRecruitmentMethodPerId(updatedRecruitmentMethod);
      setRecruitmentMethodList((old) =>
        old.map((elm) =>
          elm.id === updatedRecruitmentMethod.id
            ? updatedRecruitmentMethod
            : elm
        )
      );
    } catch (e) {
      console.error("recruitmentMethodUpdateById", e);
      throw e;
    }
  }, []);

  const values = useMemo(
    () => ({
      recruitmentMethodListGetter,
      recruitmentMethodByIdGetter,
      recruitmentMethodDeleteById,
      recruitmentMethodList,
      recruitmentMethodPerId,
      setRecruitmentMethodPerId,
      recruitmentMethodCreate,
      recruitmentMethodUpdateById,
    }),
    [
      recruitmentMethodListGetter,
      recruitmentMethodByIdGetter,
      recruitmentMethodDeleteById,
      recruitmentMethodList,
      recruitmentMethodPerId,
      setRecruitmentMethodPerId,
      recruitmentMethodCreate,
      recruitmentMethodUpdateById,
    ]
  );
  return <RecruitmentMethodContext.Provider value={values} {...props} />;
};
